<enauka-enauka-nav-bar></enauka-enauka-nav-bar>
<div class="rzewnie-container container">
  <p>
    <img src="/shared-assets/images/zeszyt/statuetka.jpg" class="img-rzewnie img-fluid projects-card-img" width="300" height="60">
  W roku szkolnym 2019/2020 udostępniliśmy wszystkim uczniom gminy Rzewnie przygotowującym się do egzaminu ósmoklasisty system zeszyt.online.
  Nie prowadziliśmy bezpośrednich zajęć z uczniami ani nie prowadziliśmy rozmów online z tymi uczniami.
  Przygotowania do egzaminu były realizowane przez nauczyciela szkolnego w godzinach zajęć lekcyjnych, który wykorzystywał zeszyt.online jako narzędzie wspomagające naukę do egzaminu.
  Sztuczna inteligencja dobierała uczniom zadania matematyczne i próbowała im pomóc w trakcie rozwiązywania zadań.</p>


  <p>Wyniki?<br/>
  Gmina, która dotychczas była jedną z najsłabszych gmin w powiecie uplasowała się na <strong>drugim miejscu w rankingu.</strong>
  Względem wcześniejszego roku szkolnego, w którym średni wynik z egzaminu z matematyki wynosił 31 procent, odnotowano <strong>wzrost o 45%</strong> (+14 pp) do 45 procent.</p>


  Uzyskane na koniec roku szkolnego <strong>2019/2020 wyniki egzaminu ósmoklasisty z matematyki</strong> w gminie Rzewnie na tle pozostałych gmin powiatu makowskiego:
  <ol>
    <li>gmina Sypniewo - 60,62 proc.</li>
    <li><strong>gmina Rzewnie - 44,67 proc.</strong></li>
    <li>gmina Młynarze - 44,52 proc.</li>
    <li>gmina Szelków - 44,26 proc.</li>
    <li>gmina Karniewo - 43,27 proc.</li>
    <li>gmina Krasnosielc - 42,06 proc.</li>
    <li>miasto Maków Maz. - 40,57 proc.</li>
    <li>gmina Czerwonka - 37,33 proc.</li>
    <li>gmina Różan - 33,07 proc.</li>
    <li>gmina Płoniawy Bramura - 28,16 proc.</li>
  </ol>
  Wyniki egzaminów z matematyki (ósmoklasisty i gimnazjalisty) w gminie Rzewnie bez dostępu do zeszyt.online<br/>
  <div class="rzewnie-wynik">
  <h5>2018/2019</h5>
  <ol>
    <li>gmina Karniewo - 52 proc.</li>
    <li>gmina Krasnosielc - 49 proc.</li>
    <li>gmina Sypniewo - 49 proc.</li>
    <li>gmina Szelków - 49 proc.</li>
    <li>miasto Maków Mazowiecki - 42 proc.</li>
    <li>gmina Czerwonka - 38 proc.</li>
    <li>gmina Różan - 34 proc.</li>
    <li>gmina Płoniawy-Bramura - 31 proc.</li>
    <li><strong>gmina Rzewnie - 31 proc.</strong></li>
    <li>gmina Młynarze - 26 proc.</li>
  </ol>
  </div>
  <div class="rzewnie-wynik">
  <h5>2017/2018</h5>
  <ol>
    <li>gminaMłynarze - 62 proc.</li>
    <li>gmina Sypniewo - 54 proc.</li>
    <li>gmina Różan - 48 proc.</li>
    <li>gmina Karniewo - 47 proc.</li>
    <li>gmina Krasnosielc - 44 proc.</li>
    <li>miasto Maków Mazowiecki - 42 proc.</li>
    <li><strong>gmina Rzewnie - 42 proc.</strong></li>
    <li>gmina Szelków - 41 proc.</li>
    <li>gmina Czerwonka - 40 proc.</li>
    <li>gmina Płoniawy-Bramura - 39 proc.</li>
  </ol>
  </div>
  <div class="rzewnie-wynik">
  <h5>2016/2017</h5>
  <ol>
    <li>gmina Sypniewo - 45 proc.</li>
    <li>gmina Szelków - 44 proc.</li>
    <li>gmina Różan - 43 proc.</li>
    <li>gmina Krasnosielc - 41 proc.</li>
    <li>gmina Karniewo - 41 proc.</li>
    <li>gmina Płoniawy-Bramura - 37 proc.</li>
    <li>miasto Maków Mazowiecki - 36 proc.</li>
    <li>gmina Młynarze - 36 proc.</li>
    <li><strong>gmina Rzewnie - 33 proc.</strong></li>
    <li>gmina Czerwonka - 29 proc.</li>
  </ol>
</div>
</div>

